module.exports = __webpack_public_path__ + "static/media/A18040103_10003_1.2a4f12b7.jpg";